<template>
    <div class="team-member">
        <base-window>
            <img class="photo" :src="photo" :alt="name" />
            <a
                v-if="portfolio"
                class="portfolio"
                :class="$mq"
                :href="portfolio"
                target="_blank"
                rel="noopener noreferrer"
            >
                <base-text type="h5">Link to portfolio</base-text>
            </a>
        </base-window>

        <div class="text">
            <base-text type="h4" class="name">{{ name }}</base-text>
            <base-text type="h5" class="position">{{ position }}</base-text>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'team-member',

        props: {
            name: {
                type: String,
                required: true,
            },

            position: {
                type: String,
                required: true,
            },

            portfolio: {
                type: String,
                required: false,
                default() {
                    return null;
                },
            },

            photo: {
                type: Array,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .team-member {
        .photo {
            width: 100%;
        }

        .portfolio {
            position: absolute;
            right: 0;
            left: 0;
            top: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba($purple, 0.5);
            text-decoration: none;
            opacity: 0;
            transition: opacity 0.2s linear;

            &:hover {
                opacity: 1;
            }

            &.mobile,
            &.tablet {
                opacity: 1;
                background: rgba($purple, 0.3);
            }
        }

        .text {
            text-align: center;

            .name {
                margin-top: 15px;
                font-size: 20px;
            }

            .position {
                margin-top: 5px;
            }

            a {
                display: block;
                color: white;
            }
        }
    }
</style>
